import IconButton, { IconButtonProps } from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { ElementType, MouseEvent } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';

const BUTTON_SIZE = 24;

interface RowActionIconButtonConfig {
  color?: IconButtonProps['color'];
  size?: 'small' | 'medium' | 'large';
  shape?: 'round' | 'square';
}

interface RowActionButtonProps {
  icon: ElementType;
  label: LangEnum;
  onClick: () => void;
  color?: string;
  slotSize?: number;
  iconButton?: RowActionIconButtonConfig;
  isActive?: boolean;
  testId?: string;
}

function RowActionButton({
  icon,
  label,
  onClick,
  color,
  slotSize = BUTTON_SIZE,
  iconButton,
  isActive,
  testId,
}: RowActionButtonProps) {
  const { translate } = useTranslation();
  const translatedLabel = translate(label);
  const {
    color: iconButtonColor = 'primary',
    size: iconButtonSize = 'medium',
    shape = 'square',
  } = iconButton ?? {};

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <Tooltip TooltipContent={translatedLabel} tabIndex={-1}>
      <IconButton
        icon={icon}
        isActive={isActive}
        testId={testId}
        ariaLabel={translatedLabel}
        tabIndex={-1}
        color={iconButtonColor}
        size={iconButtonSize}
        shape={shape}
        sx={{ width: slotSize, height: slotSize, p: 0, color }}
        onClick={handleClick}
      />
    </Tooltip>
  );
}

export { BUTTON_SIZE as ROW_ACTION_BUTTON_SLOT_SIZE };
export default RowActionButton;
